import { ApplicationState } from '../../../redux/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectTrainingsList } from '../../TrainingsList/redux/selectors';
import { ContentItemActionType } from '../../../api/types';

export const selectTrainingById = createSelector(
  [selectTrainingsList, (state: ApplicationState, id: string) => id],
  (trainings, id) => trainings.find(tr => tr.id === id),
);

export const selectTrainingAction = createSelector(
  selectTrainingById,
  (state: ApplicationState, id: string, actionType: ContentItemActionType) => [actionType],
  (training, [actionType]) => training?.actions.find(a => a.type === actionType),
);

export const selectSteps = createSelector(
  [selectTrainingsList, (state: ApplicationState, id: string, actionType: ContentItemActionType) => [id, actionType]],
  (trainings, [id, actionType]) => {
    const training = trainings.find(tr => tr.id === id);
    const action = training?.actions.find(a => a.type === actionType);
    return action?.steps || [];
  },
);
